import React, { ComponentProps, useState, useEffect } from "react";
import "./CountdownIndicator.scss";

interface CountdownIndicatorProps extends ComponentProps<"div"> {
  duration?: number;
  message?: string;
}

function CountdownIndicator({
  duration = 5,
  message = "game starts in",
  className = "",
  ...restProps
}: CountdownIndicatorProps) {
  const [countdown, setCountdown] = useState(duration);
  const indicatorLeftPosition = (countdown / duration) * 100;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown((prev) => (prev === 0 ? prev : prev - 1));
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className={`countdown-indicator ${className}`} {...restProps}>
      <div className="progress" style={{ left: `${indicatorLeftPosition}%` }} />
      <div className="message slashed-zero">
        <span>{message}</span>
        <span className="time-left">0{countdown}</span>
      </div>
    </div>
  );
}

export default CountdownIndicator;
